import styled, { css } from 'styled-components';
import { ifProp, palette } from 'styled-tools';

import { Card as _Card, minWidth, units } from '@calm-web/design-system';

export const HeaderTextWrapper = styled.div<{ $isSignup?: boolean }>`
	${ifProp(
		'$isSignup',
		css`
			${minWidth('desktop')} {
				padding: 0 ${units(10)};
			}
		`,
	)}
`;

export const Card = styled(_Card)`
	border-radius: 20px !important;
	border-color: ${palette('white')};
	text-align: center;

	${minWidth('desktop')} {
		padding: 48px !important;
	}
`;
